module.exports = __webpack_public_path__ + "static/media/banner-novo-agosto-mobile-v2.1aa2d178.jpg";